import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysOrderPurchaseDetailDialog from "../dialogTypes/MomSysOrderPurchaseDetailDialog";

function MomSysOrderPurchaseDetailButton(props) {
    const { t } = useTranslation();

    const {
        id,
        schema,
        onSuccess,
        createButtonName,
        customizeErrorMsgCallback,
        modifyUrlCallback,
        onDialogUpdateDetail,
        onSelectMst,
        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-create-button"}
                onClick={onOpen}
                createButtonName={createButtonName}
                {...others}
            />
            <MomSysOrderPurchaseDetailDialog
                id={id + "-create-dialog"}
                mode="create"
                formId={id + "-create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={modifyUrlCallback}
                onDialogUpdateDetail={onDialogUpdateDetail}
                onSelectMst={onSelectMst}
            />
        </>
    );
}

export default MomSysOrderPurchaseDetailButton;
